export default __webpack_public_path__ + "static/media/on_deck.250ceaf6.png";